
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';
import { Constants } from '../core/constants';

@Injectable()
export class LoanAccountService {
  private baseApiUrl: string;
  private documentPreviewUrl: string;
  constructor(configurationService: ConfigurationService, private constants: Constants, private httpClient: HttpClient) {
    this.baseApiUrl = configurationService.BaseApiUrl;
    this.documentPreviewUrl = `${configurationService.BasePreviewUrl}loandocument/`;
  }



  // getFiltered(filter: string, pageIndex: number, pageSize: number,
  //   sortColumn: string, sortAscending: boolean, isMaintenance: boolean = true): Observable<any> {

  //   const params = {
  //     filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
  //   };

  //   return this.httpClient.post(this.baseApiUrl + 'loanaccount/filter', params).pipe(
  //     map((res: any) => res),
  //     catchError((err: any) => observableThrowError(err.message || 'Server error')));
  // }

  getFiltered(filter: string, pageIndex: number, pageSize: number,
    sortColumn: string, sortAscending: boolean, isMaintenance: boolean = true,status: number,scheme: number): Observable<any> {

    const params = {
      filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance,status,scheme
    };

    return this.httpClient.post(this.baseApiUrl + 'loanaccount/filter', params).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getAll(forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `loanaccount?isMaintenace=${forMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getById(id: number, forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `loanaccount/${id}?isMaintenance=${forMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getByAccountNo(accountNo: any): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `loanaccount/accountno/${accountNo}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  getInterfaceReq(id: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `interfacemobilebanking/mobilebankingrequest/${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getByCustomerId(customerId: number, applicationModuleId = (this.constants.ApplicationModule.LoanEMI || this.constants.ApplicationModule.LoanRBM || this.constants.ApplicationModule.LoanFlat)
  ): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `loanaccount/customer/${customerId}?applicationModuleId=${applicationModuleId}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  computeInstallmentAndFees(computeData: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + `loanaccount/compute`, computeData).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

    computeInstallmentAndFeesForUpdate(computeData: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + `loanaccount/computeforupdate`, computeData).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  create(loanAccount: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'loanaccount', loanAccount).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  createInterfaceLoan(loanAccount: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'interfacemobilebanking/approverejectloan', loanAccount).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  createAndDisburse(loanAccount: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'loanaccount/quick', loanAccount).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

    createAndDisburserestructure(loanAccount: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'loanaccount/loanrestructure', loanAccount).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  disburseAdditional(loanAccount: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'loanaccount/disburse', loanAccount).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  enhance(loanAccount: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'loanaccount/enhance', loanAccount).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  update(loanAccount: any): Observable<any> {
    return this.httpClient.put(this.baseApiUrl + 'loanaccount', loanAccount).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  authorise(loanAccount: number): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'loanaccount/authorise', loanAccount).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  delete(id: number): Observable<any> {
    return this.httpClient.delete(this.baseApiUrl + `loanaccount/${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

     saveDownloadDatalegal(model: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'loanaccount/savedownloaddatalegal', model).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }


  createCharges(loanCharge: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'loanaccount/charge', loanCharge).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getRepayment(loanAccountId: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `loanaccount/repay/${loanAccountId}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  createRepayment(loanRepay: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'loanaccount/repay', loanRepay).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getDcbEntries(accountNo: string): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `loanaccount/dcb/${accountNo}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  // getDueDcbHistory(accountId: number): Observable<any> {
  //   return this.httpClient.get(this.baseApiUrl + `loanaccount/duedcb/${accountId}`).pipe(
  //     map((res: Response) => res),
  //     catchError((err: any) => observableThrowError(err.message || 'Server error')));
  // }

  specialauthorisation(model: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'loanaccount/specialauthorisation', model).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

    createRecommendation(model: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'loanaccount/recommendation', model).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
    getRecommendation(accountNo: string): Observable<any> {
    return this.httpClient.get(this.baseApiUrl +  `loanaccount/getrecommendation/${accountNo}`).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error'))
    );
  }

    getunauthorisedaccountno(accountNo: boolean): Observable<any> {
    return this.httpClient.get(this.baseApiUrl +  'loanaccount/getunauthorisedaccountno').pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error'))
    );
  }
 
      getAllSpecialLoanDropdown(forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `loanaccount/specialloanList?isMaintenace=${forMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getDueDcbHistory(accountId: number, generalLedgerId: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `loanaccount/duedcb/${accountId}?generalLedgerId=${generalLedgerId}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  retrieveAccountDues(accountNo: string): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `loanaccount/due/${accountNo}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  repayAccountDues(repayment: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'loanaccount/repay', repayment).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  computeRepayment(repayment: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'loanaccount/computerepayment/', repayment).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  computeSettlementRepayment(repayment: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'loanaccount/computesettlementrepayment', repayment).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getDepositAccounts(customerId: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `loanaccount/deposit/${customerId}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  // getloancalculatordetails(interestRate: DoubleRange, tenor: number, loanAmount: DoubleRange, strMethod: number, strTenureType: number, dtDate: string, additionalAmount: DoubleRange): Observable<any> {
  //   return this.httpClient.get(this.baseApiUrl + `loanaccount/loancalculator/${interestRate}?tenor=${tenor}&&loanAmount=${loanAmount}&&strMethod=${strMethod}&&strTenureType=${strTenureType}&&dtDate=${dtDate}&&additionalAmount=${additionalAmount}`).pipe(
  //     map((res: Response) => res),
  //     catchError((err: any) => observableThrowError(err.message || 'Server error')));
  // }

  getloancalculatordetailsnew(interestRate: DoubleRange, tenor: number, loanAmount: number,strMethod:number, strTenureType:number,dtDate: string,additionalAmount:DoubleRange,schemeid:number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `loanaccount/loancalculator1/${interestRate}?tenor=${tenor}&&loanAmount=${loanAmount}&&strMethod=${strMethod}&&strTenureType=${strTenureType}&&dtDate=${dtDate}&&additionalAmount=${additionalAmount}&&schemeid=${schemeid}`).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getloancalculatordetails(interestRate: DoubleRange, tenor: number, loanAmount: DoubleRange, strMethod: number, strTenureType: number, dtDate: string, additionalAmount: DoubleRange): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `loanaccount/loancalculator/${interestRate}?tenor=${tenor}&&loanAmount=${loanAmount}&&strMethod=${strMethod}&&strTenureType=${strTenureType}&&dtDate=${dtDate}&&additionalAmount=${additionalAmount}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }


  getByAccountNumber(customerId: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `loanaccount/loanaccount/${customerId}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  getDocumentContentAsDataUrl(id: number, forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(`${this.documentPreviewUrl}${id}?isMaintenance=${forMaintenance}`, { responseType: 'text' }).pipe(
      map(res => ({ id, dataUrl: res })),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  CheckForDuplicateLoanAccount(customerId: number, schemeId: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `loanaccount/duplicate/${customerId}?schemeId=${schemeId}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  CheckForDuplicateLoanRepayment(accountNo: string): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `loanaccount/checkdcb/${accountNo}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  computefutureinterest(accountNo: string, valueDate: Date): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `loanaccount/ComputeFutureInterest/${accountNo}?valueDate=${valueDate}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  loanTransfer(loanAccount: any): Observable<any> {
  return this.httpClient.post(this.baseApiUrl + 'loanaccount/loantransfer', loanAccount).pipe(
    map((res: Response) => res),
    catchError((err: any) => observableThrowError(err.message || 'Server error'))
  );
}
  getAllScheme(): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + 'loanaccount/getscheme').pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

   createPayment(payload: any): Observable<any> {
  return this.httpClient.post(this.baseApiUrl + 'paymenttransaction/payment', payload) .pipe(
     map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')
      )
    );
}

loanApplicationReject(loanAccount: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'loanaccount/loanapplicationreject', loanAccount).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
saveDownloadData(model: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'loanaccount/savedownloaddata', model).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

getschedulbyaccount(accountNo: any): Observable<any> {
    const params = new HttpParams().set('accountNo', accountNo);
  
    return this.httpClient.get(this.baseApiUrl + 'loanaccount/accountNo', { params }).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error'))
    );
  }
  // payOverDue(loanAccount: any): Observable<any> {
  //   return this.httpClient.post(this.baseApiUrl + 'loanaccount/overdue', loanAccount).pipe(
  //     map((res: Response) => res),
  //     catchError((err: any) => observableThrowError(err.message || 'Server error')));
  // }

  getloancalculatordetailsweekly(interestRate: DoubleRange, tenor: number, loanAmount: number,strMethod:number, strTenureType:number,dtDate: string,additionalAmount:DoubleRange,schemeid:number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `loanaccount/loancalculatorweekly/${interestRate}?tenor=${tenor}&&loanAmount=${loanAmount}&&strMethod=${strMethod}&&strTenureType=${strTenureType}&&dtDate=${dtDate}&&additionalAmount=${additionalAmount}&&schemeid=${schemeid}`).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
}
